export function postSectionSlider() {
    let $parent = $(".posts-section");

    if ($parent.hasClass("has-slider")) {
        let $slider = $(".posts-grid");

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: "unslick"
                },
            ]
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/postSectionSlider.js